import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import formAccessGroupMemberships from 'modules/reviews/store/collections/formAccessGroupMemberships'
import type Review from 'modules/reviews/store/models/v2/Review'

export function useReviewees(form: Review | null | undefined) {
  const formId = form?.id
  const [reviewees, setReviewees] = React.useState({})
  const [groupIds, setGroupsIds] = React.useState([])

  const fetchReviewees = async () => {
    if (!formId) return

    const { reviewees, group_ids } = await form.rpc('reviewees')
    await formAccessGroupMemberships.fetch({
      data: {
        form_id: formId,
      },
    })
    setReviewees(reviewees)
    setGroupsIds(group_ids)
  }

  const { loading } = useAsyncData(fetchReviewees, [formId])

  return {
    loading,
    reviewees,
    groupIds,
    fetchReviewees,
  }
}
